export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black py-32">
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Logo */}
        <div className="mb-12">
          <img
            src="https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/062fc0ccfb04948d5a479f8f6262a669.png"
            alt="Artist Logo"
            className="w-auto h-64 md:h-80 lg:h-96 object-contain mx-auto"
          />
        </div>

        {/* New Album Badge */}
        <a 
          href="https://music.youtube.com/watch?v=YffhQBBbnNQ&si=ObuK7IIHrkNrzim-" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center mb-8 animate-pulse cursor-pointer"
        >
          <div className="px-6 py-2 border-2 border-red-500 rounded-full bg-black/30 backdrop-blur-sm hover:bg-red-500/20 transition-all duration-300">
            <span className="text-white text-sm font-bold tracking-widest">LISTEN TO MY NEW SINGLE</span>
          </div>
        </a>

        {/* Joy + Pain Image */}
        <div className="mb-8">
          <img
            src="https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/7ed99b6e3eb7b03d5c661d6923662fd8.jpeg"
            alt="Joy + Pain"
            className="w-full max-w-2xl h-auto object-contain mx-auto rounded-lg"
          />
        </div>

        {/* Artist Name */}
        <h1 className="text-7xl md:text-9xl lg:text-[120px] font-black text-white mb-6 leading-none tracking-tight">
        </h1>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a 
            href="https://youtu.be/C1UCXyqJ6Bg?si=jGRQhjZKqfXmBupw"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 border-2 border-white bg-transparent text-white text-base font-bold rounded-full hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
          >
            WATCH VIDEO
          </a>
        </div>
      </div>
    </section>
  );
}